<template>
  <div class="content">
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption" v-if="topRotation.length > 0" ref="mySwiper_info">
            <swiper-slide v-for="(item, index) in topRotation" :key="index">
              <!-- <img :src="item.resUrl" class="imgBanner"> -->
              <img :src="item.resUrl" class="imgBanner" style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                width="930" height="380" @click="Towindowurl(item.url)" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright">
          <swiper v-if="topRotation.length > 0" :options="swiperOption2" ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation" :key="index" @click="Towindowurl(item.url)"
              :style="{ backgroundImage: 'url(' + item.resRightUrl + ')', backgroundSize: '100% 100%' }">
              <div>
                <img src="/image/index/index3tuceng.png" class="shan" />
                <div style="padding:40px 50px">
                  <div class="bannerTitle">{{ item.title }}</div>
                  <div class="bannerline"></div>
                  <div class="bannerText">
                    <span v-html="ellipsis(item.detail, 120)"></span>
                  </div>
                  <div class="marginTop20">
                    <a href="javascript:void(0);" @click="Towindowurl(item.url)" class="bannerBtn">了解更多</a>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="main display_between_nocenter EC_width">
      <div class="mainLeft coursebox t1left">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left ctop">
            <span class="normaltitle" style="margin-right:10px">学科实践</span>
            <div :class="courseType == item.id ? 'ctopbq1' : 'ctopbq'" v-for="(item, index) in topBqList" :key="index"
              @click="tobiaoqian(item.id)">{{ item.name }}</div>
          </div>
          <div class="gl_tb_right" @click="onMore(infoList[0].cid, courseTitle)">
            <a href="javascript:;" class="gl_tb_right_more">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div v-for="(item, index) in infoList" :key="index + '3'">
          <div class="gl_listWrapBar_nopad controlShow" style="margin: 20px 0;">
            <div class="gl_imgList setShow" @click="clkNews(item, infoList[0].name)">
              <img :src="item.slideShow" width="156" height="88" class="imgtran" />
            </div>
            <a href="javascript:;" class="gl_listItem display_column">
              <div class="gl_listItemTitle fontBold setShow" @click="clkNews(item, infoList[0].name)">
                {{ item.title }}
              </div>
              <div class="gl_listItemTitle disShow" style="line-height:10px;" @click="clkNews(item, infoList[0].name)">
                {{ item.title }}
              </div>
              <div class="gl_listItemTitle  setShow" @click="clkNews(item, infoList[0].name)">
                {{ ellipsis(item.abstract, 40) }}
              </div>
              <div class="display_between  setShow">
                <div>
                  <span v-bind:class="calculate(index)" v-for="(qitem, index) in (item.labelName || '').split(',')"
                    :key="index" @click="onsearch(qitem)">
                    {{ qitem }}
                  </span>
                </div>
                <div class="gl_inforshow ">
                  <span class="marginRight20">
                    {{ formatTime(item.publishtime, 'YYYY/MM/DD') }}
                  </span>
                  <span>
                    <img src="/image/index/chakan.png" />
                    {{ item.clickVolume }}
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="t2rno" v-if="infoList.length == 0">
          <p>暂无资讯</p>
        </div>
      </div>
      <div class="mainRight t1right">
        <div class="gl_title_bar marginBottom20">
          <div class="gl_tb_left">
            <span class="normaltitle">基地微对话</span>
          </div>
          <div class="gl_tb_right" @click="onMore(trlist[0].cid, '基地微对话')">
            <a href="javascript:;" class="gl_tb_right_more">
              <img src="/image/index/moreimg.png" class="gltb_moreimg" />
              更多
            </a>
          </div>
        </div>
        <div class="video_block marginTop13" v-for="(item, index) in trlist" :key="index + '1'"
          @click="clkNews(item, '基地微对话')">
          <img :src="item.slideShow" width="300" height="169" />
          <div class="video_title">
            {{ ellipsis(item.title, 17) }}
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="gl_title_bar marginBottom20 marginTop10">
        <div class="gl_tb_left titleBar">
          <span class="normaltitle">学科课程</span>
          <TitleBqList :bqList="t2bqList" :bqIng="t2bqIng" index="t2" style="width:600px;margin-left:20px"
            :changeBqIng="changeT2BqIng"></TitleBqList>
        </div>
        <div class="gl_tb_right" @click="toCourseList(t2bqList, t2bqIng)">
          <a href="javascript:;" class="gl_tb_right_more">
            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
            更多
          </a>
        </div>
      </div>
      <div class="t2box">
        <div class="t2left" v-if="t2cList.length > 0" @click="tokecheng(t2cList[0].id)">
          <!-- <img :src="t2cList[0].acr_PictResUrl"
               class="t2limg"
               alt=""> -->
          <el-image class="t2limg" :src="t2cList[0].acr_PictResUrl">
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
          <div class="t2boxbot">
            <div class="t2bbtitle">
              <span>{{ t2cList[0].title }}</span>
            </div>
            <div class="t2bbr">
              <span v-show="t2cList[0].discountStatus == 2">免费</span>
              <span v-show="t2cList[0].discountStatus == 1">VIP专享</span>
              <span v-show="t2cList[0].discountStatus == 3">￥{{ Number(t2cList[0].discount).toFixed(2) }}</span>
              <img src="../../assets/img/icon/ren.png" alt="" />
              <span style="color:#919CA3">{{ t2cList[0].playSum }}人</span>
            </div>
          </div>
        </div>
        <div class="t2rno" v-if="t2cList2.length == 0">
          <p>暂无课程</p>
        </div>
        <div class="t2right" v-if="t2cList2.length > 1">
          <div class="t2rbox" v-for="(item, index) in t2cList.slice(1, 7)" @click="tokecheng(item.id)" :key="index">
            <!-- <img :src="item.acr_PictResUrl"
                 class="t2rimg"
                 alt=""> -->
            <el-image class="t2rimg" :src="item.acr_PictResUrl">
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="t2rboxbot">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width marginTop20 marginBottom20" v-for="(item, index) in bottomRotation" :key="index"
      @click="Towindowurl(item.url)">
      <img :src="item.resUrl" alt="" width="1240" height="110" />
    </div>
    <div class="EC_width">
      <div class="gl_title_bar marginBottom20 marginTop50">
        <div class="gl_tb_left titleBar">
          <span class="normaltitle">专题课程</span>
          <TitleBqList :bqList="t2bqList2" :bqIng="t2bqIng2" index="t3" style="width:600px;margin-left:20px"
            :changeBqIng="changeT2BqIng2"></TitleBqList>
        </div>
        <div class="gl_tb_right" @click="toCourseList(t2bqList2, t2bqIng2)">
          <a href="javascript:;" class="gl_tb_right_more">
            <img src="/image/index/moreimg.png" class="gltb_moreimg" />
            更多
          </a>
        </div>
      </div>
      <div class="t2box">
        <div class="t2left" v-if="t2cList2.length > 0" @click="tokecheng(t2cList2[0].id)">
          <!-- <img :src="t2cList2[0].acr_PictResUrl"
               class="t2limg"
               alt=""> -->
          <el-image class="t2limg" :src="t2cList2[0].acr_PictResUrl || t2cList2[0].acr_Pict">
            <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
          <div class="t2boxbot">
            <div class="t2bbtitle">
              <span>{{ t2cList2[0].title }}</span>
            </div>
            <div class="t2bbr">
              <span v-show="t2cList2[0].discountStatus == 2">免费</span>
              <span v-show="t2cList2[0].discountStatus == 1">VIP专享</span>
              <span v-show="t2cList2[0].discountStatus == 3">￥{{ Number(t2cList2[0].discount).toFixed(2) }}</span>
              <img src="../../assets/img/icon/ren.png" alt="" />
              <span style="color:#919CA3">{{ t2cList2[0].playSum }}人</span>
            </div>
          </div>
        </div>
        <div class="t2rno" v-if="t2cList2.length == 0">
          <p>暂无课程</p>
        </div>
        <div class="t2right" v-if="t2cList2.length > 1">
          <div class="t2rbox" v-for="(item, index) in t2cList2.slice(1, 7)" @click="tokecheng(item.id)" :key="index">
            <!-- <img :src="item.acr_PictResUrl"
                 class="t2rimg"
                 alt=""> -->
            <el-image class="t2rimg" :src="item.acr_PictResUrl || item.acr_Pict">
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="t2rboxbot">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import TitleBqList from '../../components/titleBqList/titleBqList';
export default {
  name: 'build',
  data() {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionEnd: () => {
            const infoSwiper = this.$refs.mySwiper_info && this.$refs.mySwiper_info.swiper;
            const thumbSwiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper;
            if (
              !infoSwiper ||
              !thumbSwiper ||
              !infoSwiper.slides ||
              !thumbSwiper.slides ||
              infoSwiper.slides.length === 0 ||
              thumbSwiper.slides.length === 0
            ) {
              return;
            }
            thumbSwiper.slideTo(infoSwiper.activeIndex, 200, false);
          }
        }
      },
      swiperOption2: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
          clickable: true
        },
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionEnd: () => {
            const infoSwiper = this.$refs.mySwiper_info && this.$refs.mySwiper_info.swiper;
            const thumbSwiper = this.$refs.mySwiper && this.$refs.mySwiper.swiper;
            if (
              !infoSwiper ||
              !thumbSwiper ||
              !infoSwiper.slides ||
              !thumbSwiper.slides ||
              infoSwiper.slides.length === 0 ||
              thumbSwiper.slides.length === 0
            ) {
              return;
            }
            infoSwiper.slideTo(thumbSwiper.activeIndex, 200, false);
          }
        }
      },
      topRotation: [], //顶部轮播
      bottomRotation: [], //底部轮播
      topBqList: [],
      courseType: 0,
      infoList: [],
      trlist: [],
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block'],
      t2bqList: [],
      t2bqIng: 0,
      t2cList: [],
      t2bqList2: [],
      t2bqIng2: 0,
      t2cList2: [],
      courseTitle: ''
    };
  },
  components: {
    TitleBqList
  },
  created() {
    this.GetRotationInfo();
    this.GetGpSiteNewInfoPageList();
    this.getData();
    this.GetColumsInfoAllList();
  },
  methods: {
    getData() {
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          let dat = data.buildData.data2;
          this.t2bqList = dat.t2bqList;
          this.t2bqList2 = dat.t2bqList2;
          this.getlist(this.t2bqList[0].xtitle);
          this.getlist2(this.t2bqList2[0].xtitle);
        });
    },
    tobiaoqian(index) {
      if (this.courseType == index) return;
      this.courseType = index;
      for (let i = 0; i < this.topBqList.length; i++) {
        if (this.topBqList[i].id == index) {
          this.courseTitle = this.topBqList[i].name;
          this.GetInfoList();
        }
      }
    },
    changeT2BqIng(id) {
      this.t2bqIng = id;
      this.getlist(this.t2bqList[id].xtitle);
    },
    changeT2BqIng2(id) {
      this.t2bqIng2 = id;
      if (id == 32 || id == 33) {
        this.getAllCoures(id);
      } else {
        this.getlist2(this.t2bqList2[id].xtitle);
      }
    },
    GetRotationInfo() {
      let _this = this;
      let arr = [9, 14];
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 2
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 9) {
                _this.topRotation = res.data.data || [];
              } else if (arr[i] == 14) {
                _this.bottomRotation = res.data.data || [];
              }
            }
          });
      }
    },
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    calculate(index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    },
    Towindowurl(url) {
      if (url != null && url != '') window.open(url);
    },
    GetGpSiteNewInfoPageList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: 60,
          pageIndex: 0,
          pageSize: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let gpSiteNewInfoViewsViews = res.data.data.gpSiteNewInfoViewsViews;
            if (gpSiteNewInfoViewsViews != null && gpSiteNewInfoViewsViews.length > 0) {
              _this.trlist = gpSiteNewInfoViewsViews;
            }
          }
        });
    },
    getlist(name) {
      this.httphelper
        .post('/api/NewApi/GetDbRecommendHomeCoursePageList', {
          labelName: name,
          number: 7
        })
        .then(res => {
          if (res.data.code == 200) {
            this.t2cList = res.data.data;
          }
        });
    },
    getlist2(name) {
      this.httphelper
        .post('/api/NewApi/GetDbRecommendHomeCoursePageList', {
          labelName: name,
          number: 7
        })
        .then(res => {
          if (res.data.code == 200) {
            this.t2cList2 = res.data.data;
          }
        });
    },
    onMore(cid, conetntitle) {
      this.$router.push({
        path: '/disciconstruc/Inforlist',
        query: {
          pid: 37,
          title: conetntitle,
          cid: cid
        }
      });
    },
    tokecheng(id) {
      window.open(this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id, '_blank');
    },
    toCourseList(list, id) {
      if (id == 32 || id == 33) {
        window.open(this.httphelper.IsDebugCgphome() + '/list?type=' + id, '_blank');
      } else {
        let str = list[id].xtitle;
        window.open(this.httphelper.IsDebugCgphome() + '/allCourse?keyword=' + str, '_blank');
      }
    },
    /**新闻的点击事件 */
    clkNews(info, meuntitle) {
      //如果外连接存在，跳转外链，否则跳转详情
      if (Object.keys(info.address).length == 0) {
        var param = {
          pid: 37,
          title: meuntitle,
          cid: info.cid,
          goroutename: 'disciconstruc/Inforlist'
        };
        localStorage.setItem('Inforlist_param_' + info.cid, JSON.stringify(param));
        const { href } = this.$router.resolve({
          path: '/disciconstruc/Inforlist/inforDetails?',
          query: {
            id: info.id,
            column_Type: info.cid
          }
        });
        window.open(href, '_blank');
      } else {
        window.open(info.address);
      }
    },
    getAllCoures(id) {
      this.httphelper
        .post('/api/CourseApi/GetNaviCoursePageList', {
          navId: id,
          courseType: 0,
          orderType: 0,
          page: 1,
          limit: 7
        })
        .then(res => {
          if (res.data.code == 200) {
            this.t2cList2 = res.data.data;
          }
        });
    },
    /**获取栏目数据 */
    GetColumsInfoAllList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetColumsInfoAllList', {
          cType: 1,
          isCHorEN: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            let data = res.data.data.sort(function (a, b) {
              return a.sort - b.sort;
            });
            data.forEach(item => {
              switch (item.id) {
                case 58:
                  _this.topBqList.push(item);
                  break;
                case 59:
                  _this.topBqList.push(item);
                  break;
                case 61:
                  _this.topBqList.push(item);
                  break;
                case 215:
                  _this.topBqList.push(item);
                  break;
                case 216:
                  _this.topBqList.push(item);
                  break;
              }
            });
            //获取首页热门内容数据
            _this.courseType = _this.topBqList[0].id;
            _this.courseTitle = _this.topBqList[0].name;
            _this.GetInfoList();
          }
        });
    },
    /**获取首页中部新闻信息 */
    GetInfoList() {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetGpSiteNewInfoPageList', {
          keyword: '',
          id: 0,
          parentID: 0,
          column_Type: _this.courseType,
          pageIndex: 1,
          pageSize: 6
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.infoList = res.data.data.gpSiteNewInfoViewsViews;
          }
        });
    }
  }
};
</script>

<style scoped>
.content {
  flex: 1;
}

.bannerWrap {
  height: 450px;
  padding-top: 40px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #dbeded, #ffffff);
}

/* 上部banner */

.topbanner {
  height: 380px;
}

.bannerleft {
  width: 930px;
  height: 380px;
  /* background: #005660; */
  box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
  border-radius: 20px 0px 0px 0px;
}

.bannerright {
  width: 299px;
  height: 380px;
  /* padding: 50px 40px; */
  box-sizing: border-box;
  position: relative;
  background: #303a60;
  box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 20px 0px;
}

.swiper-container,
.swiper-slide {
  width: 100%;
  height: 100%;
}

.shan {
  position: absolute;
  right: 0;
  bottom: 0;
}

.bannerTitle {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 38px;
}

.bannerText {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 25px;
}

.bannerline {
  width: 40px;
  height: 1px;
  background: #ffffff;
  margin-top: 20px;
  margin-bottom: 18px;
}

.bannerBtn {
  display: inline-block;
  width: 121px;
  height: 32px;
  background: #ffffff;
  border-radius: 16px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 32px;
  text-align: center;
}

.swiper-pagination {
  text-align: left;
  box-sizing: border-box;
  padding-left: 20px;
}

.setShow {
  display: none;
}

.controlShow:hover .setShow {
  display: flex;
}

.controlShow:hover .disShow {
  display: none;
}

.ctop {
  display: flex;
  align-items: center;
}

.ctopbq {
  padding: 7px 20px;
  line-height: 16px;
  border: 1px solid #eee;
  border-radius: 30px;
  margin-left: 5px;
  margin-top: -10px;
  cursor: pointer;
}

.ctopbq1 {
  padding: 7px 20px;
  line-height: 16px;
  border: 1px solid #eee;
  border-radius: 30px;
  margin-left: 5px;
  margin-top: -10px;
  background-color: #0b8686;
  color: #fff;
  cursor: pointer;
}

.t1left {
  width: 880px;
}

.t1right {
  width: 300px;
}

.titleBar {
  display: flex;
}

.t2box {
  display: flex;
  margin-bottom: 35px;
}

.t2rno {
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
}

.t2limg {
  width: 521px;
  height: 293px;
}

.t2boxbot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  line-height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.t2bbtitle {
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.t2bbr img {
  margin-left: 20px;
  margin-right: 10px;
}

.t2bbr {
  color: #f01414;
}

.t2right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  margin-left: 2px;
}

.t2rbox {
  width: 207px;
  display: flex;
  flex-direction: column;
  margin-left: 32px;
}

.t2rimg {
  width: 207px;
}

.t2rboxbot {
  height: 60px;
  line-height: 18px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  padding: 10px 0 14px;
  box-sizing: border-box;
}
</style>
